import React from 'react';
import styled from 'styled-components';

const LogIcon = ({ className, icon }) => {
  return (
    <>
      <img alt="" src={icon} />
    </>
  );
};

export default styled(LogIcon)``;
